var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-toggle-card',{attrs:{"title":"Пунктирная линия","is-open":_vm.config.enabled},on:{"toggle":_vm.toggleProperty}})}
var staticRenderFns = []

export { render, staticRenderFns }